var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 12C19.7188 14.0471 18.9055 16.0104 17.458 17.458C16.0104 18.9055 14.0471 19.7188 12 19.7188C9.95286 19.7188 7.98957 18.9055 6.54202 17.458C5.09447 16.0104 4.28125 14.0471 4.28125 12C4.28125 9.95286 5.09447 7.98957 6.54202 6.54202C7.98957 5.09447 9.95286 4.28125 12 4.28125C14.0471 4.28125 16.0104 5.09447 17.458 6.54202C18.9055 7.98957 19.7188 9.95286 19.7188 12ZM2.5 12C2.5 14.5196 3.50089 16.9359 5.28249 18.7175C7.06408 20.4991 9.48044 21.5 12 21.5C14.5196 21.5 16.9359 20.4991 18.7175 18.7175C20.4991 16.9359 21.5 14.5196 21.5 12C21.5 9.48044 20.4991 7.06408 18.7175 5.28249C16.9359 3.50089 14.5196 2.5 12 2.5C9.48044 2.5 7.06408 3.50089 5.28249 5.28249C3.50089 7.06408 2.5 9.48044 2.5 12ZM11.1094 6.95312V12C11.1094 12.2969 11.2578 12.5752 11.5064 12.7422L15.0689 15.1172C15.4771 15.3918 16.0301 15.2805 16.3047 14.8686C16.5793 14.4566 16.468 13.9074 16.0561 13.6328L12.8906 11.525V6.95312C12.8906 6.45957 12.4936 6.0625 12 6.0625C11.5064 6.0625 11.1094 6.45957 11.1094 6.95312Z",
    fill: "#83D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.27ea06702267c8712a6fbe2db2393088.svg";
export { ForwardRef as ReactComponent };